import { Cookies } from 'react-cookie';

export const API_LOG_IN_REQUEST = 'API_LOG_IN_REQUEST';
export const API_LOG_IN_SUCCESS = 'API_LOG_IN_SUCCESS';
export const API_LOG_IN_FAILURE = 'API_LOG_IN_FAILURE';
export const API_REGISTRATION_REQUEST = 'API_REGISTRATION_REQUEST';
export const API_REGISTRATION_SUCCESS = 'API_REGISTRATION_SUCCESS';
export const API_REGISTRATION_FAILURE = 'API_REGISTRATION_FAILURE';

export const API_SHORT_REGISTRATION_REQUEST = 'API_SHORT_REGISTRATION_REQUEST';
export const API_SHORT_REGISTRATION_SUCCESS = 'API_SHORT_REGISTRATION_SUCCESS';
export const API_SHORT_REGISTRATION_FAILURE = 'API_SHORT_REGISTRATION_FAILURE';

export const API_LOG_IN_ADMIN_REQUEST = 'API_LOG_IN_ADMIN_REQUEST';
export const API_LOG_IN_ADMIN_SUCCESS = 'API_LOG_IN_ADMIN_SUCCESS';
export const API_LOG_IN_ADMIN_FAILURE = 'API_LOG_IN_ADMIN_FAILURE';

export const API_AUTH_ADMIN_REQUEST = 'API_AUTH_ADMIN_REQUEST';
export const API_AUTH_ADMIN_SUCCESS = 'API_AUTH_ADMIN_SUCCESS';
export const API_AUTH_ADMIN_FAILURE = 'API_AUTH_ADMIN_FAILURE';

export const API_AUTH_USER_REQUEST = 'API_AUTH_USER_REQUEST';
export const API_AUTH_USER_SUCCESS = 'API_AUTH_USER_SUCCESS';
export const API_AUTH_USER_FAILURE = 'API_AUTH_USER_FAILURE';
export const GET_TOKEN_FROM_COOKIES = 'GET_TOKEN_FROM_COOKIES';
export const API_LOG_OUT_REQUEST = 'API_LOG_OUT_REQUEST';
export const API_LOG_OUT_SUCCESS = 'API_LOG_OUT_SUCCESS';
export const API_LOG_OUT_FAILURE = 'API_LOG_OUT_FAILURE';
export const API_LOG_IN_RESET = 'API_LOG_IN_RESET';

export const API_FORGOTTEN_PASSWORD_REQUEST = 'API_FORGOTTEN_PASSWORD_REQUEST';
export const API_FORGOTTEN_PASSWORD_SUCCESS = 'API_FORGOTTEN_PASSWORD_SUCCESS';
export const API_FORGOTTEN_PASSWORD_FAILURE = 'API_FORGOTTEN_PASSWORD_FAILURE';

export const forgottenPasswordRequest = () => ({
  type: API_FORGOTTEN_PASSWORD_REQUEST,
});

export const forgottenPasswordSuccess = payload => ({
  type: API_FORGOTTEN_PASSWORD_SUCCESS,
  payload,
});

export const forgottenPasswordFailure = payload => ({
  type: API_FORGOTTEN_PASSWORD_FAILURE,
  payload,
});

export const loginReset = () => ({
  type: API_LOG_IN_RESET,
});

export const loginRequest = () => ({
  type: API_LOG_IN_REQUEST,
});

export const loginSuccess = payload => ({
  type: API_LOG_IN_SUCCESS,
  payload,
});

export const loginFailure = payload => ({
  type: API_LOG_IN_FAILURE,
  payload,
});

export const loginAdminRequest= payload =>({
  type: API_LOG_IN_ADMIN_REQUEST,
  payload,
});

export const loginAdminSuccess = payload => ({
  type: API_LOG_IN_ADMIN_SUCCESS,
  payload,
});

export const loginAdminFailure = payload => ({
  type: API_LOG_IN_ADMIN_FAILURE,
  payload,
});

export const registrationRequest = () => ({
  type: API_REGISTRATION_REQUEST,
});

export const registrationSuccess = payload => ({
  type: API_REGISTRATION_SUCCESS,
  payload,
});

export const shortRegistrationFailure = payload => ({
  type: API_SHORT_REGISTRATION_FAILURE,
  payload,
});

export const shortRegistrationRequest = () => ({
  type: API_SHORT_REGISTRATION_REQUEST,
});

export const shortRegistrationSuccess = payload => ({
  type: API_SHORT_REGISTRATION_SUCCESS,
  payload,
});

export const registrationFailure = payload => ({
  type: API_REGISTRATION_FAILURE,
  payload,
});

export const authUserRequest = () => ({
  type: API_AUTH_USER_REQUEST,
});

export const authUserSuccess = payload => ({
  type: API_AUTH_USER_SUCCESS,
  payload,
});

export const authUserFailure = payload => ({
  type: API_AUTH_USER_FAILURE,
  payload,
});

export const authAdminRequest = payload => ({
  type: API_AUTH_ADMIN_REQUEST,
  payload,
});

export const authAdminSuccess = payload => ({
  type: API_AUTH_ADMIN_SUCCESS,
  payload,
});

export const authAdminFailure = payload => ({
  type: API_AUTH_ADMIN_FAILURE,
  payload,
});

export const getTokenFromCookies = payload => ({
  type: GET_TOKEN_FROM_COOKIES,
  payload,
});

export const logoutUserRequest = payload => ({
  type: API_LOG_OUT_REQUEST,
  payload,
});

export const logoutUserSuccess = payload => ({
  type: API_LOG_OUT_SUCCESS,
  payload,
});

export const logoutUserFailure = payload => ({
  type: API_LOG_OUT_FAILURE,
  payload,
});

const cookies = new Cookies();

const initialState = {
  token: null,
  fetchingForgottenPassword: false,
  responseForgottenPassword: null,
  isLoggedIn: cookies.get('tokenCoach') !== undefined,
  fetching: false,
  isFetched: false,
  error: null,
  user: null,
  newUser: null
};

export function loginReducer(state = initialState, action) {
  
  switch (action.type) {
    case API_FORGOTTEN_PASSWORD_REQUEST:
      return {
        ...state,
        fetchingForgottenPassword: true,
      };
    case API_FORGOTTEN_PASSWORD_SUCCESS:
      return {
        ...state,
        fetchingForgottenPassword: false,
        responseForgottenPassword: action.payload,
      };
    case API_LOG_IN_RESET:
      return {
        ...state,
        ...initialState,
      };
    case GET_TOKEN_FROM_COOKIES:
      return {
        ...state,
        token: action.payload,
      };
    case API_LOG_IN_REQUEST:
    case API_LOG_IN_ADMIN_REQUEST:
      console.log('LLLLyyyy', action.payload)
      return {
        ...state,
        newUser: action.payload,
      };
    case API_AUTH_ADMIN_REQUEST:
      console.log('LLLL4bbbb', action)
      return {
        ...state,
        newUser: action.payload,
      };
    case API_REGISTRATION_REQUEST:
    case API_AUTH_USER_REQUEST:
    case API_LOG_OUT_REQUEST:
      return {
        ...state,
        fetching: true,
      };
      case API_SHORT_REGISTRATION_REQUEST:
        return {
          ...state,
          fetching: true,
        };
        case API_LOG_IN_ADMIN_FAILURE:
        return {
          ...state,
          fetching: false,
          fetched:true,
          error: action.payload,
        };
      case API_LOG_IN_SUCCESS:
        return {
          ...state,
          isLoggedIn: true,
          user: action.payload,
          token: action.payload.token
        };
        case API_AUTH_ADMIN_SUCCESS:
          console.log('LLLLg', state.newUser)
          return {
            ...state,
            user: state.newUser,
          };
      case API_LOG_IN_ADMIN_SUCCESS:
       
        var tmp = state.newUser
        tmp = {...tmp, token:action.payload.token}
       
        return {
          ...state,
          isLoggedIn: true,
          user: tmp,
          token: action.payload.token
        }
    case API_REGISTRATION_SUCCESS:
      // debugger;
      var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
      return {
        ...state,
        fetching: false,
        isLoggedIn: true,
        token,
        user: { ...state.user, ...user },
        error: null,
      };
    case API_SHORT_REGISTRATION_SUCCESS:
      // debugger;
      var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
      return {
        ...state,
        fetching: false,
        isLoggedIn: true,
        token,
        isFetched: true,
        user: { ...state.user, ...user },
        error: null,
      };
    case API_AUTH_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case API_LOG_OUT_SUCCESS:
      return {
        ...state,
        fetching: false,
        isLoggedIn: false,
        token: null,
        user: null,
      };
    case API_LOG_IN_FAILURE:
    case API_REGISTRATION_FAILURE:
    case API_AUTH_USER_FAILURE:
    case API_LOG_OUT_FAILURE:
    case API_FORGOTTEN_PASSWORD_FAILURE:
      return {
        ...state,
        fetching: false,
        isLoggedIn: false,
        error: action.payload,
        token: null,
        user: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/login.js